import { useState } from "react";
import styles from "./TagInput.module.css";

interface TagInputProps {
    tags: string[];
    setTags: (newTags: string[]) => void;
    label?: string;
}

export const TagInput = (props: TagInputProps) => {
    const { tags, setTags, label } = props;
    const [input, setInput] = useState("");

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === "Enter" && input.trim()) {
            e.preventDefault();
            if (!tags.includes(input.trim().toLowerCase())) {
                setTags([...tags, input.trim()]);
            }
            setInput("");
        }
    };

    const onClickAddTag = () => {
        if (!tags.includes(input.trim().toLowerCase())) {
            setTags([...tags, input.trim()]);
        }
        setInput("");
    };

    const removeTag = (tag: string) => {
        setTags(tags.filter((t) => t !== tag));
    };

    return (
        <div className={styles.tagInputBlock}>
            {label && <div className={styles.label}>{label}</div>}
            <div className={styles.tagInputwrapper}>
                <div className={styles.tagInput}>
                    <input
                        type="text"
                        placeholder="Теги"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={handleKeyDown}
                        className={styles.input}
                    />
                    {!!input.length && <div onClick={onClickAddTag} className={styles.addTagButton}>{`>`}</div>}
                </div>

                <div className={styles.tagsWrapper}>
                    {tags.map((tag) => (
                        <div key={tag} className={styles.tag}>
                            {tag}
                            <div className={styles.cancelButton} onClick={() => removeTag(tag)}>
                                ×
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
